// @ts-nocheck
import React from "react";
import '../css/userDashboard.css'
import { Button, Spin, Modal } from 'antd'
import { dasboardIcons } from "../dashboard-icons";
import OkrPerformanceContainer from '../containers/okrPerformanceContainer'
import CoachingConversationContainer from '../containers/coachingCoversationContainer'
import KudosAndFeedbackContainer from "../containers/kudosAndFeedbackContainer";
import UserOneOnOneContainer from "../containers/userOneOnOneContainer";
import moment from "moment-timezone";
import { SURVEY_DIVERSITY_PROFILE, SURVEY_WHOPOSHORO } from '../../../config';
import Survey360ResponseContainer from "../containers/360SurveyResponseListContainer";
import { MetaTags } from "modules/look";
import RewardPointsCardContainer from "../containers/rewardPointsCardContainer";

const UserDasboardView = (props) => {
    const { me, checkSurveyStatus, user_permission, dashboard_loading, taken_survey } = props
    const [preview_tip, SetPreviewTip] = React.useState()
    const getGreeting = () => {
        const currentTime = moment();
        const hour = currentTime.hours();
        if (hour >= 3 && hour < 12) {
            return 'Good Morning';
        } else if (hour >= 12 && hour < 17) {
            return 'Good Afternoon';
        } else if (hour >= 17 && hour < 21) {
            return 'Good Evening';
        } else {
            return '';
        }
    }



    return (
        <>
            <MetaTags title="Dashboard" description="User dashboard" />
            <div className="root-user-container">
                <Spin spinning={dashboard_loading}>
                    <div className="user-dashboard-container">
                        <div className="user-dasboard-left-container">
                            {user_permission && <div>

                                <div className={`user-dasboard-banner-for-survey-taken  `}  >
                                    <div className="dashboard-banner-section-container">
                                        <h4 className="user-board-welcome-banner-heading-taken">Welcome to MApp! </h4>
                                        <h4 className="user-board-welcome-greeting-taken">{getGreeting()} <span className="text-transform-capitalize">{me?.employee?.user?.firstName}</span>!</h4>

                                    </div>
                                    <img className="dashboard-banner-image" src={dasboardIcons?.baner_bg} alt="" />
                                </div>
                            </div>}
                            <Modal
                                visible={preview_tip}
                                footer={false}
                                closable={false}
                                centered={true}
                                destroyOnClose={true}
                                width={"90%"}
                                style={{ maxWidth: "600px" }}
                            >
                                <div style={{ width: "100%", height: "100%" }}>
                                    <div style={{ display: "flex", justifyContent: "end", width: "100%", cursor: "pointer" }}>

                                        <img src={dasboardIcons?.close_icon} alt="" onClick={() => { SetPreviewTip(null) }} />
                                    </div>
                                    <div className="soul-tip-preview-container">
                                        <img src={dasboardIcons.soul_tip_preview_gif} style={{ width: "300px" }} alt="" />
                                        <div style={{ display: 'flex', flexDirection: "row", justifyContent: "start", alignItems: "center", gap: ".5em" }}>
                                            <img src={dasboardIcons?.tip_icon} alt="" />
                                            <h4 className="baner-tip-title" style={{ cursor: "pointer", fontSize: "1.5em" }} >Soul tips </h4>
                                        </div>

                                        <h4 className="preview-tip-popup">{preview_tip}</h4>
                                    </div>

                                </div>
                            </Modal>
                            {
                                user_permission?.okr_permission && (
                                    <div>
                                        <OkrPerformanceContainer user_permission={user_permission} {...props} />
                                    </div>
                                )
                            }
                            {
                                user_permission?.coaching_engagement_permission && (
                                    <div>
                                        <CoachingConversationContainer user_permission={user_permission} {...props} />
                                    </div>
                                )
                            }
                            {
                                user_permission?.token_survey_permission && (
                                    <div>
                                        <Survey360ResponseContainer user_permission={user_permission} {...props} />
                                    </div>
                                )
                            }
                        </div>
                        <div className="user-dasboard-right-container">
                            {
                                user_permission?.reward_system_permission &&
                                <div>
                                    <RewardPointsCardContainer user_permission={user_permission} {...props} />
                                </div>
                            }
                            <h4 className="user-board-section-heading">Activity</h4>
                            {
                                taken_survey?.diversity === 0 && user_permission?.survey_permission &&
                                <div className="user-dasboard-small-card-container">
                                    <h4 className="user-dashboard-small-card-title">Diversity Profile</h4>
                                    <p className="user-dashboard-small-card-para">Diversity profile survey helps us gauge your uniqueness
                                        in every bit of your being. </p>
                                    <Button className="user-board-welcome-banner-button" style={{ height: "2.5em", fontSize: "1.1em" }} onClick={() => checkSurveyStatus({ id: SURVEY_DIVERSITY_PROFILE, type: "Diversity", is_navigate: true })}>START SURVEY</Button>
                                </div>
                            }
                            {taken_survey?.whoposhoro === 0 && user_permission?.survey_permission && <div className="user-dasboard-small-card-container">
                                <h4 className="user-dashboard-small-card-title">Whoposhoro</h4>
                                <p className="user-dashboard-small-card-para">WhoPoShoRo assesses your unique communication style, self-management, and public perception.</p>
                                <Button className="user-board-welcome-banner-button" style={{ height: "2.5em", fontSize: "1.1em" }} onClick={() => checkSurveyStatus({ id: SURVEY_WHOPOSHORO, type: "Whoposhoro", is_navigate: true })}>START SURVEY</Button>
                            </div>}
                            {user_permission?.oneonone_permission && <div>
                                <UserOneOnOneContainer user_permission={user_permission}{...props} />
                            </div>}
                            {(user_permission?.kudos_permission || user_permission?.feedback_permission) && <div>
                                <KudosAndFeedbackContainer user_permission={user_permission} {...props} />
                            </div>}

                        </div>
                    </div>
                </Spin>
            </div>
        </>
    )
}

export default UserDasboardView